import PropTypes from 'prop-types';
import styles from './FJRecordModal.module.less';
import FJModalClose from '../../FJModalClose/FJModalClose';
import FJRecordPermission from './FJRecordPermission.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJRecordDevice from './FJRecordDevice.jsx';
import FJRecording from './FJRecording.jsx';
import FJRecordSuccess from './FJRecordSuccess.jsx';
import FJConstant from '../../../../constants/FJConstant.js';

const FJRecordModal = props => {
    const {
        onClose,
        recorderDeviceList,
        recorderDeviceId,
        recorderDuration,
        recordStatus,
        onDeviceIdChange,
        onClickRecorder,
        onRetry,
        onStop,
        startRecord,
        audioUrl,
        audioName,
        useRecord,
    } = props;

    return (
        <div className={styles.box}>
            <FJModalClose onClick={onClose} />
            {recordStatus === FJConstant.NO_DEVICE_LIST || recordStatus === FJConstant.NO_PERMISSION ? (
                <FJRecordPermission />
            ) : (
                <div className={styles.content_box}>
                    <div className={styles.title}>{FJLocalStore._('record-voice')}</div>
                    {recordStatus === FJConstant.DEFAULT && (
                        <FJRecordDevice
                            list={recorderDeviceList}
                            id={recorderDeviceId}
                            onClick={onDeviceIdChange}
                            onClickRecorder={onClickRecorder}
                        />
                    )}
                    <FJRecording
                        recorderDuration={recorderDuration}
                        onRetry={onRetry}
                        onStop={onStop}
                        active={recordStatus === FJConstant.RECORDING}
                        startRecord={startRecord}
                    />
                    {recordStatus === FJConstant.SUCCESS && (
                        <FJRecordSuccess url={audioUrl} name={audioName} reRecord={onRetry} useRecord={useRecord} />
                    )}
                </div>
            )}
        </div>
    );
};
FJRecordModal.propTypes = {
    onClose: PropTypes.func,
    recorderDeviceList: PropTypes.array,
    recorderDeviceId: PropTypes.string,
    recorderDuration: PropTypes.number,
    recordStatus: PropTypes.string,
    onDeviceIdChange: PropTypes.func,
    onClickRecorder: PropTypes.func,
    onRetry: PropTypes.func,
    onStop: PropTypes.func,
    startRecord: PropTypes.func,
    audioUrl: PropTypes.string,
    audioName: PropTypes.string,
    useRecord: PropTypes.func,
};
export default FJRecordModal;
